import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import * as d3 from 'd3'

import { CellInfo } from './cell-info'
import { Comments } from '../comments/comments'
import { MatComponentsModule } from 'src/app/mat-components.module'

const timeFormatter = d3.timeFormat('%a, %b %d %Y')

@Component({
    imports: [CellInfo, Comments, MatComponentsModule, FormsModule, CommonModule],
    selector: 'app-status-modal-dem',
    template: `
    <div>
      <div class="header">
        <div class="date">{{ timeFormatter(data.data.xKey) }}</div>
        <div class="text-end pt-1">
          <mat-icon [mat-dialog-close]="true">close</mat-icon>
        </div>
      </div>
      <div class="main">
        <app-status-cell-info-dem class="detail"
            [header]='false'
            [data]="data.data"></app-status-cell-info-dem>
        <app-status-comments [topic]="commentsTopic"
            [dateFormat]="data.dateFormat"
            [newCommentType]="data.item?.config?.type_of_page?.name"
            [item]="this.data?.item"
            [maxMessageLength]='maxCommentLength'></app-status-comments>
      </div>
    </div>
  `,
    styles: [':host {display: block;background: #010103;color: white;border-radius: inherit;  .header {display: flex;flex-direction: row;justify-content: space-between ;padding: 0 10px;height: 36px;background-color: #FFFFFF33; border-radius: 10px 10px 0 0;  .date{margin: 10px 0px;}} .main{display:flex;  .detail{ height: 340px;overflow: auto;width: 340px;margin: 10px 3px;border-right: 1px dashed #727272;}}}']
})
export class Modal {
  constructor (@Inject(MAT_DIALOG_DATA) public data: any) {
    const details = this.data.data.details;
    const [file_nm, value]:any = Object.entries(details)[0];

    this.commentsTopic = {
      file_nm,
      ...value
    };
    this.maxCommentLength = parseInt(data.item?.config?.max_comment_length)
  }

  commentsTopic: any
  header: boolean = false
  public timeFormatter = timeFormatter
  maxCommentLength: number
}